<template>
    <b-overlay
            :show="loading"
            rounded="sm"
    >
        <b-row>
            <b-col>
                <b-card
                        title="جزئیات پروژه"
                >
                    <b-form
                            ref="projectform"
                            @submit.prevent
                    >
                        <b-row>

                            <b-col
                                    class="mt-2 form-size"
                                    md="6"
                                    offset-md="3"
                            >
                                <b-row>

                                    <b-col
                                            class="image"
                                            cols="12"
                                    >
                                        <b-media class="mb-2">
                                            <template #aside>
                                                <b-avatar
                                                        ref="previewEl"
                                                        :src="Form.Image"
                                                        size="90px"
                                                        rounded
                                                        button
                                                        @click="$refs.refInputEl.click()"
                                                />
                                            </template>
                                            <input
                                                    :ref="'refInputEl'"
                                                    type="file"
                                                    class="d-none"
                                                    name="Image"
                                                    @input="imageRenderer($event)"
                                            >
                                            <b-row>
                                                <b-col md="12">
                                                    <b-form-group
                                                            label="عنوان"
                                                            label-for="Title"
                                                            class="mb-0"
                                                    >
                                                        <b-form-input
                                                                id="Title"
                                                                v-model="Form.Title"
                                                                name="Title"
                                                                autocomplete="off"
                                                        />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-media>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                                label="وضعیت"
                                                label-for="Visibility"
                                        >
                                            <v-select
                                                    v-model="Form.Visibility"
                                                    :options="enums('IsActive')"
                                                    dir="rtl"
                                                    label="text"
                                                    name="Visibility"
                                                    :clearable="false"
                                                    :reduce="x => x.value"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="8">
                                        <b-form-group
                                                label="دسته بندی"
                                                label-for="BlogCategoryId"
                                        >
                                            <project-category
                                                    v-model="Form.ProjectCategoryId"
                                                    :multiple="true"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group
                                                label="تگ ها"
                                                label-for="Tag"
                                        >
                                            <b-form-tags
                                                    v-model="Form.Tag"
                                                    name="Tag"
                                                    placeholder=""
                                                    add-button-text="افزودن"
                                                    add-button-variant="outline-primary"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="12">
                                        <b-form-group
                                                label="توضیحات"
                                                label-for="Description"
                                        >
                                            <b-form-textarea
                                                    id="Description"
                                                    v-model="Form.Description"
                                                    name="Description"
                                                    rows="5"
                                                    no-resize
                                            />
                                        </b-form-group>

                                    </b-col>

                                    <b-col cols="12">
                                    <div class="divider divider-solid">
                                        <div class="divider-text" style="font-weight: 600;">گالری</div>
                                    </div>
                                    </b-col>
                                    <div
                                        v-for="(item, index) in Form.ProjectGallery"
                                        :key="item.Id"
                                        class="px-1 mb-1"
                                    >
                                        <b-avatar
                                            ref="previewEl"
                                            :src="item.Url"
                                            size="120px"
                                            rounded
                                            class="foodrecipes-image mt-1"
                                        >
                                        </b-avatar>
                                        <b-button
                                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                            variant="outline-secondary"
                                            style="margin-top: 0.5rem;"
                                            class="btn-icon video-remove"
                                            @click="removeGallery(item)"
                                        >
                                            <feather-icon
                                                icon="XIcon"
                                                size="14"
                                            />
                                        </b-button>
                                    </div>

                                    <input
                                        ref="refGalley"
                                        type="file"
                                        class="d-none"
                                        accept="image/*"
                                        @change="galleryRenderer($event)"
                                    >

                                    <div class="px-1 mb-1 mt-1">
                                        <div
                                            class="activity-upload-video"
                                            @click="$refs.refGalley.click()"
                                        >
                                            <div class="activity-upload-video-icon">
                                                <feather-icon
                                                    size="24"
                                                    icon="UploadIcon"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    <b-col class="mt-1 mb-2 text-center">
                                        <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                type="submit"
                                                variant="primary"
                                                class="mr-1"
                                                @click="save"
                                        >
                                            ذخیره
                                        </b-button>
                                        <b-button
                                                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                                variant="outline-secondary"
                                                @click="back"
                                        >
                                            بازگشت
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>

import ProjectCategory from '@/tools/projectcategory.vue'

export default {
    name: 'ProjectDetails',
    components: {ProjectCategory},
    data() {
        return {
            Form: {
                Id: null,
                Title: null,
                Image: null,
                Description: null,
                ProjectCategoryId: [],
                Visibility: true,
                ProjectGallery: []
            },
            GalleryFile: [],
            loading: false,
            galleryId: 0
        }
    },
    created() {
        if (this.$route.params.id) {
            this.Form.Id = this.$route.params.id
            this.get()
        }
    },
    methods: {
        save() {
            let url = this.$api.project.add
            if (this.$route.params.id) {
                url = this.$api.project.update
            }

            const formData = new FormData(this.$refs.projectform)
            formData.append('Id', this.Form.Id)
            formData.append('Visibility', this.Form.Visibility)

            this.Form.ProjectCategoryId.forEach(item => {
                formData.append('ProjectCategoryId', item)
            })

            this.Form.ProjectGallery.forEach((item, index) => {
                formData.append(`ProjectGallery[${index}].Id`, item.Id)
                formData.append(`ProjectGallery[${index}].Sort`, index)
                if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
                    formData.append(`ProjectGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
                }
            })

            this.loading = true
            this.$http.post(
                url, formData,
            )
                .then(() => {
                    this.back()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        imageRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.Form.Image = fileReader.result
            }
        },
        galleryRenderer(event) {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(event.target.files[0])

            fileReader.onload = () => {
                this.galleryId++

                this.Form.ProjectGallery.push({ Url: fileReader.result, Id: this.galleryId })
                this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId })
            }
        },
        removeGallery(item) {
            this.Form.ProjectGallery = this.Form.ProjectGallery.filter(x => x.Id !== item.Id)
        },
        get() {
            this.loading = true
            this.$http.post(
                this.$api.project.get, {
                    Id: this.Form.Id,
                },
            )
                .then(res => {
                    this.loading = false
                    this.Form = res.data
                })
        },
    },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
